const DEFAULT_CODE = 'DEFAULT';

const ALREADY_EXIST_NAME = 'Já existe outra Estratégia com esse nome!';

const errorMessages = {
  CREATE: {
    E40001: ALREADY_EXIST_NAME,
    [DEFAULT_CODE]: 'Ocorreu algum erro ao tentar salvar a Estratégia.',
  },
  UPDATE: {
    E40002: ALREADY_EXIST_NAME,
    [DEFAULT_CODE]: 'Ocorreu algum erro ao tentar atualizar a Estratégia.',
  },
};

export const getStrategyErrorByTypeAndCode = (
  type: 'CREATE' | 'UPDATE',
  code = DEFAULT_CODE,
): string =>
  errorMessages[type][code] ||
  [
    errorMessages[type][DEFAULT_CODE],
    code !== DEFAULT_CODE ? `(${code})` : '',
  ].join(' ');
